/* eslint-ignore */
// @ts-nocheck
export const TYPE_STEPS = Object.freeze({
  yourIdentification: 1,
  personalData: 2,
  passwordRegistration: 3,
  validation: 4,
  theEnd: 5,
});
